<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  isWorkspaceV2Path,
  workspaceV2Path,
} from 'dashboard/helper/workspaceV2';
import { worldById } from 'dashboard/routes/dashboard/hub/hubWorldLookup';
import { useMapGetter } from 'dashboard/composables/store';
import { useSmallScreen } from 'dashboard/composables/useSmallScreen';
import SettingsNav from './SettingsNav.vue';
import { settingsBarVisible } from './settingsBack';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
const router = useRouter();
const { isSmallScreen } = useSmallScreen();
const accountId = useMapGetter('getCurrentAccountId');
const menuTarget = computed(() => {
  const target = {
    name: 'settings_menu',
    params: { accountId: accountId.value },
  };
  if (!isWorkspaceV2Path(route.path)) return target;
  const fromWorld = route.query?.from_world;
  return {
    path: workspaceV2Path(router.resolve(target).path),
    ...(typeof fromWorld === 'string' && worldById(fromWorld)
      ? { query: { from_world: fromWorld } }
      : {}),
  };
});
</script>

<template>
  <div class="flex w-full h-full m-0 overflow-hidden bg-n-surface-1">
    <SettingsNav v-if="route.query.config_center !== '1'" />
    <div class="flex flex-col flex-1 h-full px-6 pt-4 pb-8 overflow-auto">
      <!-- No celular o menu e outra tela, entao a sub-tela precisa dizer como
           voltar para ela. Com a barra de contexto na tela, o voltar e dela. -->
      <RouterLink
        v-if="isSmallScreen && !settingsBarVisible(route)"
        :to="menuTarget"
        class="flex items-center self-start gap-1 mb-3 text-sm min-h-11 text-n-slate-11"
      >
        <span class="i-ph-caret-left size-4 rtl:rotate-180" />
        {{ $t('SETTINGS_NAV.TITLE') }}
      </RouterLink>
      <div class="flex items-start w-full max-w-5xl mx-auto">
        <router-view v-slot="{ Component }">
          <keep-alive v-if="keepAlive">
            <component :is="Component" :key="route.fullPath" />
          </keep-alive>
          <component :is="Component" v-else :key="route.fullPath" />
        </router-view>
      </div>
    </div>
  </div>
</template>
